module.exports = __webpack_public_path__ + "static/media/cat_medium_150.acd6b94f.png";